import React from 'react';
import './marker-radar.scss';
import Lottie from '../Lottie';
import { markerJson } from 'assets/lottie-animations/marker-radar/MarkerRadarJson';
import { Tooltip } from 'antd';
import PropTypes from 'prop-types';

const MarkerRadar = props => {
  const { radarTooltipText, tooltipVisible, desktop } = props;
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: markerJson,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };
  const size = desktop ? 150 : 100;
  return (
    <div className="marker-radar">
      <div className={`marker-radar--marker ${desktop ? 'desktop' : ''}`}>
        <Lottie height={size} width={size} options={defaultOptions} />
      </div>
      <Tooltip
        title={radarTooltipText}
        visible={tooltipVisible}
        placement="bottom"
        overlayClassName="marker-radar--marker-tooltip"
      >
        <div className="marker-radar--dummy-marker" />
      </Tooltip>
    </div>
  );
};
MarkerRadar.propTypes = {
  radarTooltipText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  tooltipVisible: PropTypes.bool,
  desktop: PropTypes.bool,
};
MarkerRadar.defaultProps = {
  radarTooltipText: 'Please place the pin accurately on the map',
  tooltipVisible: true,
  desktop: false,
};
export default MarkerRadar;
